import { useContext } from 'react';
import SectionContentGroupContext from '../../../../SectionContentGroupContext';
import FieldContext from '../../../FieldContext';
import useCurrentFieldSectionMoving from './useCurrentFieldSectionMoving';
import useMoveCurrentFieldToSectionContentGroup from './useMoveCurrentFieldToSectionContentGroup';
import useSwapPositionsWithField from './useSwapPositionsWithField';
import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';

const useFieldMoving = (
  allHighestPositions: Record<ContentGroupType, number>,
  lowestFieldPositionInSectionBottomContent: number,
): [() => Promise<void>, () => Promise<void>] => {
  const currentSectionContentGroup = useContext(SectionContentGroupContext);
  const { previousField, nextField } = useContext(FieldContext);

  const [moveCurrentFieldToPreviousSection, moveCurrentFieldToNextSection] =
    useCurrentFieldSectionMoving();

  const moveCurrentFieldToSectionContentGroup =
    useMoveCurrentFieldToSectionContentGroup(
      allHighestPositions,
      lowestFieldPositionInSectionBottomContent,
    );

  const swapPositionsWithField = useSwapPositionsWithField();

  const moveUp = async (): Promise<void> => {
    if (
      !previousField &&
      currentSectionContentGroup !== ContentGroupType.BOTTOM
    ) {
      await moveCurrentFieldToPreviousSection();

      return;
    }

    if (!previousField) {
      await moveCurrentFieldToSectionContentGroup(ContentGroupType.LEFT);

      return;
    }

    await swapPositionsWithField(previousField);
  };

  const moveDown = async (): Promise<void> => {
    if (!nextField && currentSectionContentGroup === ContentGroupType.BOTTOM) {
      await moveCurrentFieldToNextSection();

      return;
    }

    if (!nextField) {
      await moveCurrentFieldToSectionContentGroup(ContentGroupType.BOTTOM);

      return;
    }

    await swapPositionsWithField(nextField);
  };

  return [moveUp, moveDown];
};

export default useFieldMoving;
